import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

/**
 * Redux Action
 */
import { 
    get_rule_request,
    get_rules_request
} from './rules'

/**
 * Get Rule Template
 */

export const get_rule_template_request = (ruletid, uid = null) => dispatch => {
    

    API
    .getRuleTemplateByRULETID (ruletid)
    .then(info => {
        
        try {
            const {
                ruleTemplate
            } = info

            dispatch(get_rule_template_success(ruleTemplate, uid))
            ruleTemplate && ruleTemplate.rules && dispatch(get_rule_request(ruleTemplate.rules))


        } catch(err) {
            message.error('Error in getting rule templates. Refresh page?')
        }

    })
}

const get_rule_template_success = (ruleTemplate, uid = null) => {
    return {
        type: ActionTypes.GET_RULE_TEMPLATE,
        ruleTemplate,
        uid
    };
}

/**
 * Get Rule Templates
 */

 export const get_rule_templates_request = (ruletids, uid = null) => dispatch => {

    let ruletidBatch = []

    ruletids.map((ruletid, index) => {

        ruletidBatch.push(ruletid)

        if( 
            (index+1) % REDUX.REDUX_RULE_TEMPLATE_BATCH_GET_SIZE === 0
            ||
            index+1 === ruletids.length
        ) {
            dispatch(batch_get_rule_templates_request(ruletidBatch, uid))
            ruletidBatch = []
        }

        return null
    })
 }

/**
 * Batch Get Rule Templates
 */
 export const batch_get_rule_templates_request = (ruletids, uid = null) => dispatch => {

    API
    .getRuleTemplateBatch(ruletids)
    .then(info => {
        
        try {
            const {
                ruleTemplates
            } = info

            dispatch(batch_get_rule_templates_success(ruleTemplates, uid))

            ruleTemplates 
            && ruleTemplates.length 
            && dispatch(
                get_rules_request(
                    ruleTemplates.reduce((acc, cur) => [...acc, ...cur.rules], [])
                )
            )


        } catch(err) {
            message.error('Error in batch getting rule templates. Refresh page?')
        }

    })
}

const batch_get_rule_templates_success = (ruleTemplates, uid = null) => {
    return {
        type: ActionTypes.GET_RULE_TEMPLATES,
        ruleTemplates,
        uid
    };
}


export const create_rule_template_request = (items, cb = () => {}) => dispatch => {
    API
    .createRuleTemplate(items)
    .then(info => {
        
        try {
            const {
                ruleTemplate,
                status,
                msg
            } = info

            if(status === 200) {
                dispatch(create_rule_template_success(ruleTemplate, items.uid))
                cb()
            } else if(status === 401) {
                message.warning(`Failed in creating rule template. ${msg}`)
            } else {
                message.error('Error in creating rule template. Refresh page?')
            }

        } catch(err) {
            message.error('Error in creating rule template. Refresh page?')
        }

    })
}

const create_rule_template_success = (ruleTemplate, uid) => {
    return {
        type: ActionTypes.CREATE_RULE_TEMPLATE,
        ruleTemplate,
        uid
    };
}
export const update_rule_template_request = (items, cb = () => {}) => dispatch => {
    API
    .updateRuleTemplate(items)
    .then(info => {
        
        try {
            const {
                ruleTemplate,
                notification,
                status,
                msg
            } = info

            if(status === 200) {
                dispatch(update_rule_template_success(ruleTemplate, notification, items.uid))
                cb()
            } else if(status === 401) {
                message.warning(`Failed in creating rule template. ${msg}`)
            } else {
                message.error('Error in creating rule template. Refresh page?')
            }

        } catch(err) {
            message.error('Error in creating rule template. Refresh page?')
        }

    })
}

const update_rule_template_success = (ruleTemplate, notification, uid) => {
    return {
        type: ActionTypes.CREATE_RULE_TEMPLATE,
        ruleTemplate,
        notification,
        uid
    };
}

export const delete_rule_template_request = (ruletid) => dispatch => {
    API
    .deleteRuleTemplate(ruletid)
    .then(info => {
        const { status, msg } = info

        if(status === 200) {
            dispatch(delete_rule_template_success(ruletid))
        } else {
            message.warning(msg)
        }
    })
}

const delete_rule_template_success = (ruletid) => {
    return {
        type: ActionTypes.DELETE_RULE_TEMPLATE,
        ruletid
    }
}

export const add_rule_in_rule_template_success = (ruletid, ruleid) => {
    return {
        type: ActionTypes.ADD_RULE_IN_RULE_TEMPLATE,
        ruletid,
        ruleid
    }
}